'use strict';

var polyfill = require('./polyfill.js');
var index = require('../define-properties/index.js');

var getPolyfill = polyfill;
var define = index;

var shim = function shimValues() {
	var polyfill = getPolyfill();
	define(Object, { values: polyfill }, {
		values: function testValues() {
			return Object.values !== polyfill;
		}
	});
	return polyfill;
};

module.exports = shim;
